import React, { useState, useEffect } from "react"
import { withRouter } from "react-router-dom"
import Format from "../../functions/format"

function CardList(props) {
    const [loading, setLoading] = useState(true)
    const [count, setCount] = useState(0)
    const [list, setList] = useState([])
    const [page, setPage] = useState({
        size: 1,
        index: 1
    })
 
    useEffect(() => {
        setLoading(props.loading)
    }, [props.loading])

    useEffect(() => {
        setCount(props.count)
    }, [props.count])

    useEffect(() => {
        setList(props.lists)
    }, [props.lists])

    useEffect(() => {
        setPage(props.page)
    }, [props.page])

    return (
        <div className="card">
            <div className="card-body p-3 p-md-4">
                <p>ทั้งหมด {(loading) ? "..." : Format.price(count)} คอร์ส</p>
                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead className="text-nowrap">
                            <tr>
                                <th scope="col">Course Code</th>
                                <th scope="col">Session Number</th>
                                <th scope="col">ชื่อหลักสูตร</th>
                                <th scope="col">สถานที่</th>
                                <th scope="col">วันที่อบรม</th>
                                <th scope="col" width="200px">ตัวเลือก</th>
                            </tr>
                        </thead>
                        {(loading || list.length === 0) ?
                            <tbody>
                                <tr>
                                    <td colSpan={6}>
                                        {(loading) ?
                                            <div className="text-center">
                                                <div className="spinner-border text-warning" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div> :
                                            <p className="text-muted text-center mb-0">ยังไม่มีข้อมูล</p>
                                        }
                                    </td>
                                </tr>
                            </tbody> :
                            <tbody>
                                {list.map((item, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{item.code}</td>
                                            <td>{item.session}</td>
                                            <td>{item.title}</td>
                                            <td>{item.place}</td>
                                            <td>{Format.convertToISOToDateString(item.date)}</td>
                                            <td >
                                                <div className="text-nowrap">
                                                    <button type="button" className="btn btn-info-old me-2" onClick={() => props.handleUpdate(item)}><i className="bi bi-pencil-square me-2"></i>แก้ไข</button>
                                                    <button type="button" className="btn btn-danger" onClick={() => props.handleRemove(item.id)}><i className="bi bi-trash-fill me-2"></i>ลบ</button>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        }
                    </table>
                </div>
                <div className="mb-3">
                    <nav aria-label="Page navigation">
                        <ul className="pagination justify-content-center">
                            <li className={"page-item" + (page.index !== 1 ? "" : " disabled")}>
                                <span className="page-link pointer" onClick={() => props.handleChangeActive("-")}>{"<<"}</span>
                            </li>
                            {Format.genPagination(page.index, page.size, count).map((item, i) => {
                                return (
                                    <li className={"page-item" + (item === page.index ? " active" : "")} key={i}>
                                        <span className="page-link pointer" onClick={() => props.handleChangeActive(item)}>{item}</span>
                                    </li>
                                )
                            })}
                            <li className={"page-item" + (Math.ceil((count/page.size)) > page.index ? "" : " disabled")}>
                                <span className="page-link pointer" onClick={() => props.handleChangeActive("+")}>{">>"}</span>
                            </li>
                        </ul>
                    </nav>
                </div>

            </div>
        </div>
    )
}

export default withRouter(CardList)